import _ from 'underscore';
import Backbone from 'backbone';
import ProjectUtil from "./project-util";
import FormValidator from "../../lib/validate";
import MathUtil from "./math-util";

// create FormUtil
class FormUtil {
	constructor() {
		// add support for Backbone events
		_.extend(this, Backbone.Events);
	}

	init(dataObj) {
		if (!dataObj) {
			return;
		}
		const self = this;
		// store argument references
		this.pubSub = dataObj.pubSub;
		this.$form = dataObj.$form;
		this.formName = dataObj.formName;
		this.$feedback = dataObj.$feedback;
		this.action = dataObj.action;
		this.context = dataObj.context || null; // allow some extra context to be passed along - allow context for the action if it can be called from multiple user flows in the same view, for example
		this.hasGender = dataObj.hasGender || false;
		this.hasDOB = dataObj.hasDOB || false;
		this.dobRequired = dataObj.dobRequired || false;
		//this.saveActions = dataObj.saveActions; // Array of accepted values: 'contest', 'mailchimp'
		this.minAge = (dataObj.hasOwnProperty('minAge')) ? dataObj.minAge : 18; // sweeps must be 18, subscribe must be 13.
		this.checkValidPassword = dataObj.checkValidPassword || false;
		this.validateFieldsAr = dataObj.validateFieldsAr || [];
		this.paramsAr = dataObj.paramsAr || [];
		this.autoSubmit = dataObj.autoSubmit || false;
		this.handleSubmit = (dataObj.handleSubmit === false) ? false : true; // if this is false, event needs to be handled externally.
		this.$curBtn = dataObj.$curBtn;

		// Add Event listeners
		$('input[name="dob-month"],input[name="dob-day"],input[name="dob-year"]').on('change', function () {
			self.handleAgeValidate();
		});

		// Listen for password input updates
		if (this.checkValidPassword) {
			$('#password', this.$form).on('input', function (e) {
				self.handlePasswordFieldInput(e);
			});
		}

		if (this.autoSubmit) {
			// not using the form validation
			this.submitFormData();
		} else {
			// prepare form validation
			this.buildFormValidation();
		}

		return this;
	}

	/**
	 * Parse the fields array to get values for each
	 */
	getFormData(tParamsAr) {
		var self = this,
			tVal,
			tData = {};
		_.each(tParamsAr, function (tParam) {
			switch (tParam.type) {

				case 'val':
					// simplest case - get the field value
					tData[tParam.param] = self.$form.find('input[name="' + tParam.field + '"]').val();
					break;

				case 'textareaStripped':
					// val stripped of html
					tData[tParam.param] = $('<p>' + self.$form.find('textarea[name="' + tParam.field + '"]').val() + '</p>').text();
					break;
				case 'checkbox':
					// get a 1 or 0, depending on checkbox value
					tData[tParam.param] = self.$form.find('input[name="' + tParam.field + '"]').prop('checked') ? 1 : 0;
					break;

				case 'useValueParam':
					// use the provided value
					tData[tParam.param] = tParam.value;
					break;

				case 'numeric':
					// get the numeric value of the field value
					tVal = self.$form.find('input[name="' + tParam.field + '"]').val();
					tVal = tVal.match(/\d/g);
					if (tVal && tVal.length) {
						tData[tParam.param] = tVal.join('');
					} else {
						tData[tParam.param] = '';
					}
					break;

				case 'phone':
					// get the numeric value of the field value
					tVal = self.$form.find('input[name="' + tParam.field + '"]').val() || ''; // default to empty string because phone field might not exist
					tVal = self.processPhoneValue(tVal);
					if (tVal && tVal.length === 10) {
						tData[tParam.param] = tVal;
					} else {
						tData[tParam.param] = '';
					}
					break;

				case 'dob':
					// gender could be a single field [iOS] or multi-field [non-iOS].
					if (ProjectUtil.isIOS()) {
						tData[tParam.param] = self.$form.find('input[name="dob"]').val();
					} else {
						// create the dob from the three fields.  Use fixed names of 'dob-month', 'dob-day', 'dob-year' for this type.
						if (self.$form.find('input[name="dob-month"]').length &&
							self.$form.find('input[name="dob-month"]').val().length &&
							self.$form.find('input[name="dob-day"]').length &&
							self.$form.find('input[name="dob-day"]').val().length &&
							self.$form.find('input[name="dob-year"]').length &&
							self.$form.find('input[name="dob-year"]').val().length) {
							// format the date at YYYY-MM-DD
							tData[tParam.param] = self.$form.find('input[name="dob-year"]').val() + '-' + MathUtil.padNumber(self.$form.find('input[name="dob-month"]').val(), 2) + '-' + MathUtil.padNumber(self.$form.find('input[name="dob-day"]').val(), 2);
						} else {
							tData[tParam.param] = '';
						}
					}
					break;

				case 'gender':
					// gender could be a select [mobile] or radio [desktop].  Use fixed name of 'gender' for this type.
					if ($('body').hasClass('desktop')) {
						// get radio value
						tData[tParam.param] = self.$form.find('input[name="gender"]:checked').val() || '';
					} else {
						// get select value
						tData[tParam.param] = self.$form.find('select[name="gender"]').val();
					}
					break;

				case 'checkedList':
					var checkedListAr = [];
					// this returns a pipe-delinated list of ids.  checkbox inputs must have class to be included in this list
					_.each($('input[type="checkbox"].' + tParam.class + ':checked'), function (checkboxEl) {
						checkedListAr.push($(checkboxEl).data('id'));
					});
					tData[tParam.param] = checkedListAr.join('|');
					break;
			}

		});

		return tData;
	}

	submitFormData() {
		var self = this;
		// don't submit if this.handleSubmit is false.
		if (!this.handleSubmit) {
			this.pubSub.trigger('formValidationSuccess', { action: self.action, response: null, context: self.context });
			return;
		}
		//submit the form
		ProjectUtil.requestAPI(
			"a=" + self.action,
			self.getFormData(self.paramsAr),
			function (response) {
				// dispatch an event
				self.pubSub.trigger('formUtilSubmitDone', { action: self.action, response: response, context: self.context });
				if (self.$curBtn) {
					self.$curBtn.removeClass('loading');
				}
			},
			function (jqXHR, textStatus) {
				self.pubSub.trigger('formUtilSubmitFail', { action: self.action, response: textStatus, context: self.context });
				if (self.$curBtn) {
					self.$curBtn.removeClass('loading');
				}
			}
		);
	}

	buildFormValidation() {
		var self = this,
			$formField,
			$input,
			$errorIndicators,
			$errorMessage;

		// special case for DOB / iOS - TODO: Make this work
		if (this.hasDOB) {
			if (ProjectUtil.isIOS()) {
				this.validateFieldsAr = this.validateFieldsAr.concat([
					{
						name: 'dob',
						display: 'Date of Birth',
						rules: 'callback_obscure_min_year',
						param: 'dob',
					},
				]);
			} else {
				this.validateFieldsAr = this.validateFieldsAr.concat([
					{
						name: 'dob-month',
						display: 'Month',
						rules: 'min_length[1]|max_length[2]|numeric|less_than[13]',
					},
					{
						name: 'dob-day',
						display: 'Day',
						rules: 'min_length[1]|max_length[2]|numeric|less_than[32]',
					},
					{
						name: 'dob-year',
						display: 'Year',
						rules: 'exact_length[4]|numeric|greater_than[1900]|callback_obscure_min_year',
					},
				]);
			}
		}

		// process 'error-indicators' for each form-group
		_.each($('.form-group', this.$form), function (tEl) {
			var $tEl = $(tEl);
			// find the inputs in each form group
			$formField = $('input, select, textarea', $tEl);
			// cycle through form fields and add appropriate elements to $errorIndicators and $errorMessages selectors
			_.each($formField, function (input) {
				$input = $(input);
				if ($formField.closest('.form-group').hasClass('item-single')) {
					// define error elements for each standard input
					$errorIndicators = $input.add($input.siblings('label')); // the input and the input's sibling label
					$errorMessage = $input.siblings('.error-message');
				} else if ($formField.closest('.form-group').hasClass('item-group')) {
					// define error elements for item groups
					$errorIndicators = $input.closest('.item-group').find('.item-group-label'); // the item-group header
					$errorMessage = $errorIndicators.siblings('.error-message'); // this error message and the item-group-label need to be siblings
				} else {
					//console.log('nope');
					//console.log($formField);
				}
				if ($errorIndicators) {
					// error indicators were found, store reference to them
					$input.data('error-indicators', $errorIndicators);
					$input.data('error-message', $errorMessage);
					$(input).on('focus', function () {
						$(input).data('error-indicators').removeClass('error');
						$(input).data('error-message').html('');
					});
				}
			});
		});
		//set up the form validator - form ID and array of form objects to validate
		this.validator = new FormValidator(this.formName, this.validateFieldsAr,
			function (errors, e) {
				//don't auto-submit the form
				if (e && e.preventDefault) {
					e.preventDefault();
					e.stopPropagation();
				}

				// handle no this.$curBtn
				if (!self.$curBtn) {

					// use the submitter if available, otherwise use an empty set
					self.$curBtn = (e && e.submitter) ? $(e.submitter) : $();
				}
				// check for errors
				if (errors.length > 0) {
					//handle errors
					var $input,
						totalErrors = errors.length,
						i;

					// track adobe error
					//Tracking.adobeTrackDirect('sweeps', 'Sweeps Form', 'form-error', this.adobeFormPageName);

					for (i = 0; i < totalErrors; i++) {
						//define current input with the error
						if (errors[i].id) {
							$input = $('#' + errors[i].id, self.$form);
						} else {
							$input = $('input[name=' + errors[i].name + ']');
						}
						if ($input) {
							// set error classes
							$input.data('error-indicators').addClass('error');
							// set error message
							$input.data('error-message').html(errors[i].message);
						}
					}

				} else {
					// success, handle form submission
					self.handleAgeValidate();
					//hide keyboard on mobile - this is dumb but it will trigger handleAgeValidate 3x on desktop
					$('input', self.$form).blur();
					// add a loading class to the submit button.  Remove this when finished?
					self.$curBtn.addClass('loading');
					// submit
					self.submitFormData(e);
				}
			}
		);

		// custom phone number validation
		this.validator.registerCallback('valid_phone', function (value) {
			var processed = self.processPhoneValue(value);
			// make sure there are 10 numbers
			if (processed && processed.length === 10) {
				return true;
			}
			return false;
		})
			.setMessage('valid_phone', 'Please enter a 10-digit phone number.');

		// custom age less_than validation for year, for obscure messaging to 'not tip off entrants as to what year they need to include.'
		this.validator.registerCallback('obscure_min_year', function () {
			/*
			if (value <= new Date().getFullYear() - (self.minAge - 1)) {
				return true;
			}
			return false;
			*/
			var tBirthdate = self.$form.find('input[name="dob"]').val();
			// cobble together DOB from the three fields
			if (self.$form.find('input[name="dob-month"]').length &&
				self.$form.find('input[name="dob-day"]').length &&
				self.$form.find('input[name="dob-year"]').length) {

				// this is not iOS, so cobble together the DOB as YYYY-MM-DD
				tBirthdate = self.$form.find('input[name="dob-year"]').val() + '-' + MathUtil.padNumber(self.$form.find('input[name="dob-month"]').val(), 2) + '-' + MathUtil.padNumber(self.$form.find('input[name="dob-day"]').val(), 2);
			}
			return self.ageValidate(tBirthdate);
		})
			.setMessage('obscure_min_year', 'Invalid date.');

		// custom yt url validation
		this.validator.registerCallback('valid_yt_url', function (url) {
			if (url !== undefined || url !== '') {
				var processed = url.match(/^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=|\?v=)([^#\&\?]*).*/);
				if (processed && processed[2].length === 11) {
					// valid
					return true;
				} else {
					// not valid
					return false;
				}
			}
			return false;
		})
			.setMessage('valid_yt_url', 'Please enter a valid YouTube URL.');

		// custom password validation
		this.validator.registerCallback('pw_compliant', function (value) {
			return self.validatePassword(value);
		})
			.setMessage('pw_compliant', 'Your password does not meet all of the requirements.');

	}

	processPhoneValue(value) {
		// trim whitespace
		value = value.trim();
		// trim special characters 
		value = value.replace(/[+-\s\.()]/gi, '');
		var processed = value.match(/^[\+]?[1]?([-\s\.]?[(]?[2-9]{1}\d{2}[)]?[-\s\.]?[2-9]{1}\d{2}[-\s\.]?[0-9]{4})$/);
		// make sure there are 10 numbers
		if (processed && processed.length > 1 && processed[1].length === 10) {
			return processed[1];
		}
		return '';
	}

	/**
	 * Calculate the user's age based on their birthday
	 */
	calculateAge(tBirthdate) { // tBirthdate is a Date
		var ageDifMs = Date.now() - tBirthdate.getTime(), // milliseconds
			ageDate = new Date(ageDifMs); // miliseconds from epoch
		return Math.abs(ageDate.getUTCFullYear() - 1970);
	}

	/**
	 * Confirm that the dateString makes the user the minAge or older.
	 */
	ageValidate(dateString) { //YYYY-MM-DD
		// console.log('[FormUtil].ageValidate :: calculated age: ', this.calculateAge(new Date(dateString)), this.minAge);
		return (this.calculateAge(new Date(dateString)) >= this.minAge);
	}

	/**
	 * Attempt to validate age. Triggered by value change on DOB input fields
	 */
	handleAgeValidate() {
		var self = this,
			tBirthdate,
			$month;

		function clearDateErrors($tMonth) {
			// clear error classes
			$tMonth.data('error-indicators').removeClass('error');
			// set error message
			$tMonth.data('error-message').html('');
		}
		// make sure if the fields exist
		if (self.$form.find('input[name="dob-month"]').length &&
			self.$form.find('input[name="dob-day"]').length &&
			self.$form.find('input[name="dob-year"]').length) {
			// define $month
			$month = self.$form.find('input[name="dob-month"]');
			// fields exist, make sure hey have value
			if (self.$form.find('input[name="dob-month"]').val().length &&
				self.$form.find('input[name="dob-day"]').val().length &&
				self.$form.find('input[name="dob-year"]').val().length) {
				// fields have value, create bithdate String
				tBirthdate = self.$form.find('input[name="dob-year"]').val() + '-' + MathUtil.padNumber(self.$form.find('input[name="dob-month"]').val(), 2) + '-' + MathUtil.padNumber(self.$form.find('input[name="dob-day"]').val(), 2);
				// confirm age is valid.  Show an error if it is not.
				if (!self.ageValidate(tBirthdate)) {
					//define current input with the error
					if ($month) {
						// set error classes
						$month.data('error-indicators').addClass('error');
						// set error message
						$month.data('error-message').html('Invalid date.');
					}
				} else {
					if ($month) {
						clearDateErrors($month);
					}
				}
			} else {
				clearDateErrors($month);
			}
		}
	}


	/************************************************************
	 *                   PASSWORD VALIDATION
	 ************************************************************/


	/**
	 * Internal function
	 * Validate a password string against a given regex rule.  Update the password rule <li> based on the value passing or not.
	 */
	validatePasswordRule(value, regex, fieldName) {
		var $field = $('li.' + fieldName);
		if (value.match(regex)) {
			// update item as passing
			$field.addClass('pass');
			return true;
		}
		// update item as failing
		$field.removeClass('pass');
		return false;
	}

	/**
	 * Internal function
	 * Validate all required password rules to confirm password meets requirements.
	 */
	validatePassword(value) {
		var validUpper = false,
			validLower = false,
			validNumber = false,
			validSpecial = false,
			validLength = false;

		// Check for uppercase number
		validUpper = this.validatePasswordRule(value, /(.*[A-Z])/, 'uppercase-char');

		// Check for lowercase number
		validLower = this.validatePasswordRule(value, /(.*[a-z])/, 'lowercase-char');

		// Check for number
		validNumber = this.validatePasswordRule(value, /(.*\d)/, 'number-char');

		// Check for spcial character
		validSpecial = this.validatePasswordRule(value, /(.*[^\w\s]|[_])/, 'special-char');

		// Check length: must be 8-32 characters
		validLength = this.validatePasswordRule(value, /^.{8,32}$/, 'char-length');

		// If all rules pass, then this will return true.
		return (validUpper && validLower && validNumber && validSpecial && validLength);
	}

	/**
	 * Internal function
	 * Check password against the rules on each update.
	 */
	handlePasswordFieldInput(e) {
		this.validatePassword($(e.currentTarget).val());
	}

	/**
	 * Clean up all listeners, remove whatever can be removed.
	 */
	destroy() {
		// validator won't exist for auto-submit forms
		if (this.validator) {
			this.validator.form.onsubmit = null;
			delete this.validator;
			$('input[name="dob-month"],input[name="dob-day"],input[name="dob-year"]').off('change');
			$('#password', this.$form).off('input');
		}
	}
}

export default FormUtil;